import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61bc96b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "size-ttl" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "hide-mobile" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "hide-desktop" }
const _hoisted_13 = {
  key: 0,
  class: "hide-mobile"
}
const _hoisted_14 = { key: 3 }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 0,
  class: "hide-mobile"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["form-option", { selected: _ctx.isSelected }])
  }, [
    (_ctx.optionType == 'color')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.option.cssColor)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                style: _normalizeStyle({ backgroundColor: _ctx.option.cssColor })
              }, null, 4))
            : _createCommentVNode("", true),
          (_ctx.option.textureIcon)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                style: _normalizeStyle({ backgroundImage: `url(${require('@/assets/' + _ctx.option.textureIcon)})` })
              }, null, 4))
            : _createCommentVNode("", true),
          _createElementVNode("p", {
            innerHTML: _ctx.option.specialHtml ? _ctx.option.specialHtml : _ctx.option.name
          }, null, 8, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.optionType == 'bagsize')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("img", {
            src: require('@/assets/' + _ctx.option.image)
          }, null, 8, _hoisted_4),
          _createElementVNode("p", _hoisted_5, [
            _createElementVNode("span", {
              innerHTML: _ctx.option.specialHtml ? _ctx.option.specialHtml : _ctx.option.name
            }, null, 8, _hoisted_6)
          ]),
          (_ctx.option.desc)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                class: "size-txt hide-mobile",
                innerHTML: _ctx.option.desc
              }, null, 8, _hoisted_7))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.optionType == 'texture')
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("span", {
              innerHTML: _ctx.option.specialHtml ? _ctx.option.specialHtml : _ctx.option.name
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("img", {
            src: require('@/assets/' + _ctx.option.image)
          }, null, 8, _hoisted_11),
          _createElementVNode("p", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_ctx.option.specialHtml ? _ctx.option.specialHtml.replace('<br>', '') : _ctx.option.name), 1)
          ]),
          (_ctx.option.textureHint)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.option.textureHint), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.optionType == 'textureTextBottom')
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("img", {
            src: require('@/assets/' + _ctx.option.image)
          }, null, 8, _hoisted_15),
          _createElementVNode("p", null, _toDisplayString(_ctx.option.specialHtml ? _ctx.option.specialHtml.replace('<br>', '') : _ctx.option.name), 1),
          (_ctx.option.textureHint)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.option.textureHint), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}